/* eslint-disable @typescript-eslint/naming-convention */
import type { IInfinitePatternResponse } from "../../types";

import classes from "./styles.module.scss";

import { Typography } from "@/components/atoms/typography";

export function PatternItem(props: IInfinitePatternResponse) {
  const { disease_name, id, name } = props;

  return (
    <div className={classes.terminologyCard}>
      <div className={classes.terminologyCard__header}>
        <Typography
          fontWeight={"medium"}
          fontFamily={"dana"}
          fontSize={"md-high"}
        >
          {name}
        </Typography>
        <Typography
          fontFamily={"dana"}
          fontSize={"xs"}
          fontWeight={"regular"}
          variant={"caption1"}
        >
          {id}
        </Typography>
      </div>
      {disease_name?.value?.trim() && (
        <Typography variant={"description2"}>{disease_name?.value}</Typography>
      )}
    </div>
  );
}
